import { Formik } from "formik";
import React, { useState, useEffect } from "react";
import { FormProduksiAsetContent } from "./__RealisasiProduksiAsetComps__";
import { useMutation, useQuery } from "react-query";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import RealisasiProduksiAsetApi from "./__RealisasiProduksiAsetApi__";
import {
  formInitialValues,
  formSubmitValueMapper,
  formValidationSchema,
} from "./__RealisasiProduksiAsetUtils__";
import { Alert, DataStatus } from "components";

export const RealisasiProduksiAsetCreate = ({ setNavbarTitle }) => {
  const history = useHistory();
  const { id } = useParams();

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    text: "",
    variant: "primary",
  });

  const {
    data: detailPermintaanAset,
    isFetching: loadingDetailPermintaanAset,
  } = useQuery(
    ["permintaanAset", "single", id],
    () =>
      RealisasiProduksiAsetApi.getSingleProduksiAsetAvailable({
        id_produksi_aset: id,
      }),
    { enabled: !!id }
  );

  const realisasiProduksiAaset = useMutation((data) =>
    RealisasiProduksiAsetApi.create(data)
  );

  const formSubmitHandler = (value) => {
    realisasiProduksiAaset
      .mutateAsync(formSubmitValueMapper(value))
      .then(() =>
        history.push("/transaksi/realisasi-produksi-aset", {
          alert: {
            variant: "primary",
            show: true,
            text: "Data berhasil disimpan!!!",
          },
        })
      )
      .catch((err) =>
        setAlertConfig({
          variant: "danger",
          show: true,
          text: "Data gagal disimpan!!!",
        })
      );
  };

  useEffect(() => {
    setNavbarTitle("Realisasi Produksi Aset");
    return () => {};
  }, []);

  return (
    <>
      <Alert
        show={alertConfig?.show}
        text={alertConfig?.text}
        variant={alertConfig?.variant}
        onClose={() =>
          setAlertConfig({
            ...alertConfig,
            show: false,
          })
        }
        showCloseButton
      />
      {loadingDetailPermintaanAset ? (
        <DataStatus text="Memuat Data..." loading />
      ) : (
        <Formik
          enableReinitialize
          initialValues={formInitialValues(detailPermintaanAset?.data ?? {})}
          onSubmit={formSubmitHandler}
          validationSchema={formValidationSchema}
        >
          <FormProduksiAsetContent action="create" />
        </Formik>
      )}
    </>
  );
};
